export default __webpack_public_path__ + "static/media/welcome-onboard.5cdea66e.png";